
import { getReservationCategoryList } from '@/api/reservationCategory';
import { getStoreInfoList } from '@/api/storeInfo';
import moment from 'moment';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { addFavoriteItem, deleteFavoriteItem } from '@/api/favoriteItem';
import { UserModule } from '@/store/user';
import { getOptionItemList } from '@/api/optionItem';
import InfiniteLoading from 'vue-infinite-loading';
import { getCurrentPosition } from '@/utils/mylocation';
import {
  getLat,
  getLng,
  setLat,
  setLng,
} from '@/utils/cookies';
import { LatLng } from '../latlng';

@Component({
  components: {
    InfiniteLoading,
  },
})

export default class extends Vue {
  @Watch('filterOptionVisible')
  private handleChangeFilterOptionVisible() {
    if (!this.filterOptionVisible) {
      (this.$refs.priceSlider as any).$refs.button1.handleMouseLeave();
      (this.$refs.priceSlider as any).$refs.button2.handleMouseLeave();
      document.documentElement.classList.remove('noscr');
    } else {
      document.documentElement.classList.add('noscr');
    }
  }

  @Watch('searchPrice', { deep: true })
  private handleChangeSearchPrice() {
    if (this.searchPrice && this.searchPrice.length === 2) {
      this.listQuery.startPrice = this.searchPrice[0];
      this.listQuery.endPrice = this.searchPrice[1];
    }
  }

  mounted() {
    this.getCategoryList();
    this.setUserLocation();
    this.getRegionList();
  }

  private filterOptionVisible = false;

  private searchAsync = false;

  private listQuery: any = {
    searchValue: this.$route.query.searchValue,
    page: 1,
    size: 20,
    startDate: this.$route.query.startDate ? this.$route.query.startDate : moment().format('YYYY-MM-DD'),
    // lat: this.$route.query.lat ? this.$route.query.lat : '37.566826', 유니드
    // lng: this.$route.query.lng ? this.$route.query.lng : '126.9786567', 유니드
    lat: this.$route.query.lat ? this.$route.query.lat : '34.81762395218535', // 남해마늘연구소
    lng: this.$route.query.lng ? this.$route.query.lng : '127.92101314625813', // 남해마늘연구소
    sort: 'recommand',
    region: this.$route.query.region ? this.$route.query.region : '',
    startPrice: 0,
    endPrice: 500000,
    categories: '',
    options: '',
    industryIdx: 4,
    filterCnt: 0,
  };

  private regionList = [];

  private apiUrl = process.env.VUE_APP_COMMON_API;

  private filterDefault = {
    date: '',
    personnel: '성인2명 / 아동1명',
    personnelAdult: 2,
    personnelChild: 1,
    village: '',
  }

  private filterSortDrawer = false;

  private restaurantList: any = [];

  private totalElements: Number = 0;

  private categoryList: any = [];

  private loading = false;

  private searchCategories = [];

  private searchOptions = [];

  private searchPrice = [0, 500000];

  private isNoMore = false;

  private sortList = [
    { label: '추천순', value: 'recommand' },
    { label: '거리순', value: 'distance' },
  ]

  private restaurantSearch = '';

  hasSortOption(value: string): boolean {
    return this.sortList.some((item) => item.value === value);
  }

  // 남해군인지 외부인지 비교를 위한 변수
  private latLng = { lat: 0, lng: 0 };

  private async setUserLocation() {
    try {
      const position = await getCurrentPosition();
      this.listQuery.lat = position.lat;
      this.listQuery.lng = position.lng;
    } catch (error) {
      this.$message.error('위치 정보를 가져오는 데 실패했습니다.');
    }
    this.getRestaurantList();
  }

  private handleClickSort(sort: string) {
    this.loading = true;
    this.listQuery.page = 0;
    this.restaurantList = [];
    this.filterSortDrawer = false;
    this.listQuery.sort = sort;
    this.getRestaurantList();
  }

  private getSortLabel() {
    let label = '';
    const idx = this.sortList.findIndex((sort: any) => sort.value === this.listQuery.sort);
    if (idx > -1) label = this.sortList[idx].label;
    return label;
  }

  private getRestaurantList() {
    this.loading = true;
    getStoreInfoList({ ...this.listQuery, useDate: this.listQuery.startDate }).then((res) => {
      this.restaurantList = this.restaurantList.concat(res.data.content);
      this.isNoMore = res.data.last;
      this.loading = false;
      this.searchAsync = false;
    });
  }

  private getRegionList() {
    getOptionItemList('REGION').then((res) => {
      this.regionList = res.data;
    });
  }

  private handleMoreStoreList() {
    this.listQuery.page += 1;
    this.getRestaurantList();
  }

  private getCategoryList() {
    getReservationCategoryList({ typeUid: '13' }).then((res) => {
      this.categoryList = res.data;
    });
  }

  private async handleSearch() {
    this.loading = true;

    if (this.searchAsync) {
      this.$message.error('검색중 입니다. 잠시만 기다려 주십시오.');
    } else {
      this.searchAsync = true;
      this.listQuery.page = 1;
      this.restaurantList = [];
      this.listQuery.categories = this.searchCategories.join(',');
      this.listQuery.options = this.searchOptions.join(',');
      this.getRestaurantList();
    }
  }

  private handleAddFavoriteItem(idx: any) {
    if (UserModule.token) {
      addFavoriteItem({ storeInfoIdx: idx }).then(() => {
        this.$message.success('저장되었습니다.');
      });
    } else {
      this.$message.info('로그인이 필요한 서비스입니다.');
    }
  }

  private handleMoreRestaurantList($state: any) {
    this.listQuery.page += 1;
    this.loading = true;
    getStoreInfoList(this.listQuery).then((res) => {
      this.loading = false;
      this.restaurantList = this.restaurantList.concat(res.data.content);
      if (res.data.content.length > 0) {
        $state.loaded();
      } else {
        this.isNoMore = true;
        $state.complete();
      }
    }).catch((error) => {
      this.$message.error('숙소를 불러오는데 실패했습니다.');
      this.loading = false;
      $state.complete();
    });
  }

  private handleApplyFilter() {
    this.filterOptionVisible = false;
    this.handleSearch();
    this.listQuery.filterCnt = this.getFilterList().length; /* 검색영역의 선택한 필터 갯수 */
  }

  private getFilterList() {
    const filterList: any = [];

    this.searchCategories.forEach((category: any) => {
      const index = this.categoryList.findIndex((x: any) => x.uid === category);
      if (index > -1) filterList.push(this.categoryList[index].name);
    });

    return filterList;
  }

  private filterOptionChange() {
    this.filterOptionVisible = !this.filterOptionVisible;
  }

  private truncateText(text: string, maxLength: number): string {
    if (text.length > maxLength) {
      return `${text.slice(0, maxLength)}...`;
    }
    return text;
  }

  private distanceType(distance: number | string): number {
    const value = Number(distance);
    if (value > 1000) {
      return value / 1000;
    }
    return 0;
  }

  private favoriteFlag = false;

  private async handleAddFavoriteStay(event: Event, idx: any, type: number) {
    if (this.favoriteFlag) {
      this.$message.info('저장중입니다.');
      return;
    }
    this.favoriteFlag = true;
    if (UserModule.token) {
      const target = (event.target as HTMLElement)?.parentElement?.parentElement?.parentElement?.parentElement;
      if (target?.classList.contains('active')) {
        if (target.getAttribute('data-id')) {
          await deleteFavoriteItem(target.getAttribute('data-id')).then(() => {
            this.$message.success('삭제되었습니다.');
            target.classList.remove('active');
            target.removeAttribute('data-id');
          });
        } else {
          this.$message.info('해당 서비스를 찾을 수 없습니다.');
        }
      } else if (target && !(target?.classList.contains('active'))) {
        let query = {};
        if (type === 1) query = { stayIdx: idx };
        else if (type === 2) query = { storeInfoIdx: idx };
        await addFavoriteItem(query).then((res) => {
          this.$message.success('저장되었습니다.');
          target.classList.add('active');
          target.setAttribute('data-id', res.data);
        });
      }
    } else {
      this.$message.info('로그인이 필요한 서비스입니다.');
    }
    this.favoriteFlag = false;
  }

  private restaurantNavigateToDetail(storeIdx: string) {
    const params = { idx: storeIdx };
    const query = { ...this.$route.query, ...this.listQuery };
    this.$router.push({ name: 'RestaurantView', params, query });
  }
}
